import Button from 'components/utils/Button';
import ButtonDropdown from 'components/utils/ButtonDropdown';
import Checkbox from 'components/utils/Checkbox';
import DropDown from 'components/utils/DropDown';
import Icon from 'components/utils/Icon';
import Modal from 'components/utils/Modal';
import Tooltip from 'components/utils/Tooltip';
import useTranslation from 'hooks/useTranslation';
import { useCallback } from 'react';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SELECT_LOCALES } from 'tools/constants';

import style from './index.style';
import { useIsEmbedded } from '../../../../hooks/useIsEmbedded';
import FiltersRef from '../FiltersRef';
import { InlineIcon } from '@iconify/react';
import { isIOS, isSafari } from 'react-device-detect';
import useShareOnSocial from '../../../../hooks/useShareOnSocial';

export default function ActionBar({
  selectedProducts,
  onClickSelectAll = () => {},
  onClickDeselectAll = () => {},
  selectAllAlert,
  onClickAddToList = () => {},
  onClickIconList = () => {},
  onClickIconGrid = () => {},
  selectedTags,
  setSelectedTags = () => {},
  onSubmitFilters = () => {},
  catalogIndex,
  options,
  searchText = () => {},
  hasFiltered,
  filters = {},
  setSort = () => {},
  handleChangeLang,
  handleCountryShip,
  handleCurrency,
  currency,
  setPage,
  publicList = false,
}) {
  const { TRANSLATIONS } = useTranslation();
  const description = useSelector((state) => state?.description);
  const countries = useSelector((state) => state?.countries);
  const shippingCountry = useSelector((state) => state?.shippingCountry);
  const checked = !!selectedProducts?.length;
  const [cardsStyle, setCardsStyle] = useState('');
  const minimize = useSelector((state) => state.handleSidebar);
  const [goingDown, setgoingDown] = useState(false);
  const [modalOpen, setModalOpen] = useState({ type: '', index: -1 });
  const handleModal = useCallback(({ type, index }) => {
    setModalOpen({ type, index });
  }, []);
  const [modalLangOpen, setModalLangOpen] = useState(false);
  const PERMISSIONS = useSelector((state) => state.permissions);
  const handleModalOpen = useCallback(() => {
    setModalLangOpen(true);
  }, []);
  const isEmbedded = useIsEmbedded();
  const { shareOnSocial } = useShareOnSocial({});

  const currencies =
    useSelector((state) => state.setting)?.find(
      (setting) => setting.type === 'options'
    )?.body?.currency || [];

  const optionsLang = useMemo(
    () =>
      Object.keys(SELECT_LOCALES).map((language) => ({
        label: SELECT_LOCALES[language]?.title,
        value: language,
      })),
    []
  );

  const optionsCountry = useMemo(
    () =>
      Object.keys(countries).map((address, index) => ({
        label: countries[index]?.country,
        value: countries[address]?.countrycode,
      })),
    [countries]
  );

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 200) {
        setgoingDown(true);
      } else {
        setgoingDown(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [goingDown]);
  return (
    <>
      <FiltersRef
        onClickIconList={onClickIconList}
        onClickIconGrid={onClickIconGrid}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        onSubmitFilters={onSubmitFilters}
        searchText={searchText}
        hasFiltered={hasFiltered}
        filters={filters}
        setPage={setPage}
      />
      <Modal
        openModal={modalOpen?.type && modalOpen?.index >= 0}
        onClose={() => {
          handleModal({ type: '', index: -1 });
        }}
        width={'350px'}
        title={
          modalOpen.type === 'currency'
            ? `${TRANSLATIONS.products.list.titleModalCurrency}`
            : `${TRANSLATIONS.products.list.titleModalCountry}`
        }
      >
        <div className="d-f fd-c relative">
          <div className="col-12">
            {modalOpen.type === 'currency' ? (
              <DropDown
                options={currencies.map((currency) => ({
                  label: currency.name,
                  value: currency.code,
                }))}
                placeholder={TRANSLATIONS.products.list.changeCurrency}
                onChange={handleCurrency}
                defaultValue={currency}
              />
            ) : (
              <DropDown
                options={optionsCountry}
                placeholder={TRANSLATIONS.products.list.selectCountry}
                defaultValue={shippingCountry}
                onChange={handleCountryShip}
              />
            )}
            <Button
              label={TRANSLATIONS.products.list.confirm}
              className={'primary medium mt-md wide'}
              onClick={() => {
                handleModal({ type: '', index: -1 });
              }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        openModal={modalLangOpen}
        onClose={() => {
          setModalLangOpen(false);
        }}
        width={'350px'}
        height={'auto'}
        title={TRANSLATIONS.products.list.selectLanguage}
      >
        <div className="d-f fd-c relative">
          <div className="col-12">
            <DropDown
              options={optionsLang}
              onChange={handleChangeLang}
              defaultValue={description}
              placeholder={TRANSLATIONS.products.detail.placeholder}
            />
            <Button
              label={TRANSLATIONS.products.list.confirm}
              className={'primary medium mt-md wide'}
              onClick={() => {
                setModalLangOpen(false);
              }}
            />
          </div>
        </div>
      </Modal>
      <div
        className={`ai-c d-f jc-sb actions-container ${
          goingDown && checked ? 'sticky' : ''
        } ${isEmbedded ? 'embedded-actions-container' : ''} ${
          !minimize ? 'l-xl' : 'l-sm'
        }`}
        id="product"
      >
        <div className={`ai-c d-f button-group ${checked ? ' active' : ''}`}>
          {!publicList && !PERMISSIONS.IS_FREE_USER && (
            <Button className="check-button medium">
              <div
                onClick={
                  checked ? onClickDeselectAll : () => onClickSelectAll(false)
                }
                className={`checkbox-container ${
                  checked ? 'checkbox-container-selected g-10' : ''
                }`}
              >
                <Checkbox
                  name="remember"
                  checked={checked}
                  label={
                    selectedProducts?.length > 0
                      ? `${selectedProducts?.length} `
                      : TRANSLATIONS.channel.edit.selectProduct
                  }
                />{' '}
              </div>
            </Button>
          )}
          {checked && (
            <>
              {selectAllAlert && (
                <div className={`select-all-alert`}>
                  <div
                    onClick={() => onClickSelectAll(true)}
                    className={'info-text info-cta'}
                  >
                    {TRANSLATIONS.products.list.selectAllProduct}
                  </div>
                </div>
              )}
              {catalogIndex !== '-2' ? (
                <div className="sort-button">
                  <ButtonDropdown
                    label={
                      PERMISSIONS.IS_FREE_USER
                        ? TRANSLATIONS.cart.sellNow
                        : TRANSLATIONS.orders.list.filter.addToImportList
                    }
                    className="action medium"
                    iconAfter="chevron-down"
                  >
                    <div className="sort">
                      <ul>
                        {options.map((catalog) => (
                          <li
                            key={catalog?.label}
                            onClick={() => {
                              onClickAddToList(catalog?.value);
                            }}
                          >
                            <p>{catalog?.label}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </ButtonDropdown>
                </div>
              ) : (
                <Button
                  label={`${TRANSLATIONS.orders.list.filter.addTo} ${
                    options.at(-1).label
                  }`}
                  className="medium"
                  onClick={() => onClickAddToList('-2')}
                />
              )}
            </>
          )}
        </div>
        {!(goingDown && checked) && (
          <div className={'d-f jc-sb ai-c g-30 buttons-container'}>
            {!publicList && (
              <>
                {' '}
                <Tooltip
                  className={'bottom'}
                  text={TRANSLATIONS.products.list.changeCurrency}
                >
                  <div className="d-f ai-c jc-c select-language">
                    <Icon
                      type="dollar-sign"
                      onClick={() => {
                        handleModal({ type: 'currency', index: 1 });
                      }}
                    />
                  </div>
                </Tooltip>
                <Tooltip
                  className={'bottom'}
                  text={TRANSLATIONS.products.list.changeLang}
                >
                  <div className="d-f ai-c jc-c select-language">
                    <Icon type="language" onClick={handleModalOpen} />
                  </div>
                </Tooltip>
                <ButtonDropdown
                  className="action-card medium"
                  iconAfter={`${cardsStyle === 'list' ? 'list' : 'grid'}`}
                >
                  <div className="sort">
                    <ul>
                      <li
                        className="d-f jc-sb"
                        onClick={() => {
                          onClickIconList();
                          setCardsStyle('list');
                        }}
                      >
                        <Icon
                          type="list"
                          className={`${
                            cardsStyle === 'list' ? 'selected' : ''
                          } selectable`}
                        />
                        <p>{'List'}</p>
                      </li>
                      <li
                        className="d-f jc-sb"
                        onClick={() => {
                          onClickIconGrid();
                          setCardsStyle('grid');
                        }}
                      >
                        <Icon
                          type="grid"
                          className={`${
                            cardsStyle === 'grid' ? 'selected' : ''
                          } selectable`}
                        />
                        <p>{'Grid'}</p>
                      </li>
                    </ul>
                  </div>
                </ButtonDropdown>{' '}
              </>
            )}
            <div className="sort-wrapper">
              <ButtonDropdown
                className="action-trasparent"
                iconAfter="swap_vert"
              >
                <div className="sort">
                  <li onClick={() => setSort('refId-desc')}>
                    {TRANSLATIONS.products.list.filter.new}
                  </li>
                  <li onClick={() => setSort('refId-asc')}>
                    {TRANSLATIONS.products.list.filter.old}
                  </li>
                  <li onClick={() => setSort('brand-asc')}>
                    {TRANSLATIONS.products.list.filter.brandsAZ}
                  </li>
                  <li onClick={() => setSort('brand-desc')}>
                    {TRANSLATIONS.products.list.filter.brandsZA}
                  </li>
                </div>
              </ButtonDropdown>
            </div>
            {PERMISSIONS.IS_ONLY_SOCIAL && (
              <div onClick={shareOnSocial} className={'social-icon'}>
                <InlineIcon
                  icon={
                    isIOS || isSafari
                      ? 'ic:outline-ios-share'
                      : 'ic:round-share'
                  }
                  style={{ fontSize: 18 }}
                />
              </div>
            )}
          </div>
        )}
      </div>
      <style jsx>{style}</style>
    </>
  );
}
